import { captureException } from '@sentry/node';

import contentRequest from '~/src/api/requests/contentRequest';


/**
 * Получить манию
 * @param {string} domain
 * @return {Promise}
 */
export function getManiaReward(providerId) {
    try {
        return contentRequest.get(`/v1/manias?providerId=${providerId}`);
    } catch (e) {
        captureException(`get manias failed: ${e.message}`);
        return {
            items: [],
        };
    }
}
